export const trackRecipientPageview = () => {
  window.dataLayer.push({
    event: 'pageview',
    destination_url: window.location.pathname,
  });
};
